import {
  Button,
  Card,
  CardContent,
  FormControl,
  Grid,
  InputLabel,
  TextField,
  Typography,
  Backdrop,
  CircularProgress,
  Box,
} from "@material-ui/core";
import React, { useState } from "react";
import { useNotification } from "../../hooks/useNotification";
import useStyles from "../../themes/style.js";
import { yupResolver } from "@hookform/resolvers/yup";
import * as Yup from "yup";
import { useForm } from "react-hook-form";
import { jwtDecode } from "jwt-decode";
import axios from "axios";
import { useEffect } from "react";
import LeftPrfileImage from "../../images/profile/profileLeftImg.png";

const UpdateProfile = ({ userDetails,onUpdate }) => {
  const classes = useStyles();
  const token = localStorage.getItem("token");
  const decode = jwtDecode(token);
  const handleNotificationCall = useNotification();

  const [loader, setLoader] = useState(false);

  const validationSchema = Yup.object().shape({
    email: Yup.string()
      .required("Email is required")
      .email("Email must be a Valid Email Address"),
    firstName: Yup.string().max(255).required("First Name is required"),
    lastName: Yup.string().max(255).required("Last Name is required"),
    mobile: Yup.string()
      .required("Mobile is required")
      .min(10, "Must be exactly 10 digits")
      .max(10, "Must be exactly 10 digits"),
    companyName: Yup.string().max(255).required("Company Name is required"),
  });

  const {
    register,
    handleSubmit,
    setValue,
    reset,
    formState: { errors, isSubmitting },
  } = useForm({
    resolver: yupResolver(validationSchema),
  });

  useEffect(() => {
    if (userDetails) {
      setValue("email", userDetails?.email);
      setValue("firstName", userDetails?.recruiter.firstName);
      setValue("lastName", userDetails?.recruiter.lastName);
      setValue("mobile", userDetails?.recruiter?.mobile);
      setValue("companyName", userDetails?.recruiter?.companyName);
    }
  }, [userDetails]);

  function updateProfile(values) {
    return new Promise((resolve) => {
      setLoader(true);

      axios({
        method: "post",
        url: `${process.env.REACT_APP_SERVER}admin/updateProfile`,
        data: {
          id: decode.user_id,
          firstName: values.firstName,
          lastName: values.lastName,
          companyName: values.companyName,
          mobile: values.mobile,
          email: values.email,
          employeeId: values.employeeId,
        },
        headers: {
          "Content-Type": "application/json",
          Authorization: token,
        },
      })
        .then(function (response) {
          if (response.data.status === true) {
            localStorage.setItem("firstName", values.firstName);
            localStorage.setItem("email", values.email);
            localStorage.setItem("mobile", values.mobile);
            localStorage.setItem("companyName", values.companyName);

            handleNotificationCall("success", response.data.message);
            onUpdate();
          } else {
            handleNotificationCall("error", response.data.message);
          }
          resolve();
          setLoader(false);
        })
        .catch(function (error) {
          console.log(error);
        });
    });
  }

  return (
    <Card className={classes.root}>
      <form onSubmit={handleSubmit(updateProfile)}>
        <CardContent className={classes.root}>
          <Grid container direction="row" alignItems="flex-start" spacing={2}>
            <Grid item xs={12}  sm={12} md={6}>
              <Grid container direction="row" spacing={2}>
                <Grid item xs={12}>
                  <Typography variant="subtitle1">Change Profile Details</Typography>
                </Grid>
                <Grid item xs={12}>
                  <InputLabel shrink htmlFor="firstName">
                    First Name
                  </InputLabel>
                  <FormControl className={classes.margin}>
                    <TextField
                      InputProps={{ disableUnderline: true }}
                      classes={{ root: classes.customTextField }}
                      size="small"
                      placeholder="Enter First Name"
                      id="firstName"
                      name="firstName"
                      {...register("firstName")}
                      error={errors.firstName ? true : false}
                    />

                    <Typography variant="inherit" color="error">
                      {errors.firstName?.message}
                    </Typography>
                  </FormControl>
                </Grid>

                <Grid item xs={12}>
                  <InputLabel shrink htmlFor="lastName">
                    Last Name
                  </InputLabel>
                  <FormControl className={classes.margin}>
                    <TextField
                      InputProps={{ disableUnderline: true }}
                      classes={{ root: classes.customTextField }}
                      size="small"
                      placeholder="Enter Last Name"
                      id="lastName"
                      name="lastName"
                      {...register("lastName")}
                      error={errors.lastName ? true : false}
                    />

                    <Typography variant="inherit" color="error">
                      {errors.lastName?.message}
                    </Typography>
                  </FormControl>
                </Grid>

                <Grid item xs={12}>
                  <InputLabel shrink htmlFor="email">
                    Email
                  </InputLabel>
                  <FormControl className={classes.margin}>
                    <TextField
                      InputProps={{ disableUnderline: true }}
                      classes={{ root: classes.customTextField }}
                      size="small"
                      placeholder="Enter Email"
                      id="email"
                      name="email"
                      {...register("email")}
                      error={errors.email ? true : false}
                    />

                    <Typography variant="inherit" color="error">
                      {errors.email?.message}
                    </Typography>
                  </FormControl>
                </Grid>

                <Grid item xs={12}>
                  <InputLabel shrink htmlFor="mobile">
                    Mobile
                  </InputLabel>
                  <FormControl className={classes.margin}>
                    <TextField
                      InputProps={{ disableUnderline: true }}
                      classes={{ root: classes.customTextField }}
                      size="small"
                      placeholder="Enter Mobile"
                      id="mobile"
                      name="mobile"
                      {...register("mobile")}
                      error={errors.mobile ? true : false}
                    />

                    <Typography variant="inherit" color="error">
                      {errors.mobile?.message}
                    </Typography>
                  </FormControl>
                </Grid>

                <Grid item xs={12}>
                  <InputLabel shrink htmlFor="companyName">
                    Company Name
                  </InputLabel>
                  <FormControl className={classes.margin}>
                    <TextField
                      InputProps={{ disableUnderline: true }}
                      classes={{ root: classes.customTextField }}
                      size="small"
                      placeholder="Enter Company Name"
                      id="companyName"
                      name="companyName"
                      {...register("companyName")}
                      error={errors.companyName ? true : false}
                    />

                    <Typography variant="inherit" color="error">
                      {errors.companyName?.message}
                    </Typography>
                  </FormControl>
                </Grid>

                <Grid item xs={12}>
                  <InputLabel shrink htmlFor="employeeId">
                    Employee ID
                  </InputLabel>
                  <FormControl className={classes.margin}>
                    <TextField
                      InputProps={{ disableUnderline: true }}
                      classes={{ root: classes.customTextField }}
                      size="small"
                      placeholder="Enter Employee ID"
                      id="employeeId"
                      name="employeeId"
                      {...register("employeeId")}
                      error={errors.employeeId ? true : false}
                    />

                    <Typography variant="inherit" color="error">
                      {errors.employeeId?.message}
                    </Typography>
                  </FormControl>
                </Grid>
                <Grid item xs={12}>
                  <Box display="flex" gridGap={8}>
                    <Button
                      variant="contained"
                      color="primary"
                      size="small"
                      type="submit"
                      disabled={isSubmitting}
                    >
                      Update
                    </Button>
                  </Box>
                </Grid>
              </Grid>
            </Grid>
            <Grid item xs={12} sm={12} md={6}>
              <img src={LeftPrfileImage} alt="Profile Left Image"  className="img-fluid d-lg-block d-none" width="100%" />
            </Grid>
          </Grid>
        </CardContent>

      </form>
      <Backdrop className={classes.backdrop} open={loader}>
        <CircularProgress color="inherit" />
      </Backdrop>
    </Card>

  );
};

export default UpdateProfile;
